"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalizationServiceV2 = exports.PersonalizationDataSource = void 0;
var PersonalizationDataSource;
(function (PersonalizationDataSource) {
    PersonalizationDataSource[PersonalizationDataSource["Behavioural"] = 0] = "Behavioural";
    PersonalizationDataSource[PersonalizationDataSource["Campaign"] = 1] = "Campaign";
})(PersonalizationDataSource || (exports.PersonalizationDataSource = PersonalizationDataSource = {}));
class PersonalizationServiceV2 {
    async getContentVariant(useCaseName, featureAppId, personalizationType = PersonalizationDataSource.Behavioural) {
        if (personalizationType === PersonalizationDataSource.Behavioural) {
            return {
                contentId: "default",
                trackParam: "default",
                iterationId: "no-iteration",
            };
        }
        return {
            contentId: "default",
            trackParam: "no-match#none",
        };
    }
    async getSortedContentVariants(contentIds, featureAppId, useCaseName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    personalizationType = PersonalizationDataSource.Behavioural) {
        return contentIds.map((id) => ({
            contentId: id,
            trackParam: id,
            iterationId: "no-itertion",
        }));
    }
}
exports.PersonalizationServiceV2 = PersonalizationServiceV2;
//# sourceMappingURL=index.js.map